import { render } from "./HorizontalCarousel.vue?vue&type=template&id=4f1890ea&scoped=true"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js"

import "./HorizontalCarousel.vue?vue&type=style&index=0&id=4f1890ea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1890ea"]])

export default __exports__